import script from "./BrandSetup.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandSetup.vue?vue&type=script&setup=true&lang=js"

import "./BrandSetup.vue?vue&type=style&index=0&id=450caad7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-450caad7"]])

export default __exports__